import React from "react";
import { ShieldCheck } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";

const CLAUSES = [
  ["Garanzia 14 giorni — Rimborso totale", "Entro 14 giorni dal primo acquisto di un piano Pro puoi chiedere il rimborso totale, senza dover dare una motivazione."],
  ["Rimborso parziale (Pro annuale)", "Dopo i primi 14 giorni, per il Pro annuale è possibile un rimborso parziale per i mesi interi non ancora utilizzati."],
  ["Pro mensile", "Il Pro mensile non è rimborsabile dopo i 14 giorni: puoi disdire in qualsiasi momento e il piano resta attivo fino alla fine del mese pagato."],
  ["Offerta Fondatore e Pass a Vita", "Acquisto in prevendita (1–20 dicembre 2026): rimborso totale se lo chiedi entro il 7 febbraio 2027. Acquisto dopo la prevendita: rimborso totale entro 14 giorni. Con il rimborso il posto Fondatore torna disponibile."],
  ["Disservizi gravi", "In caso di indisponibilità prolungata del servizio imputabile a MyQuoteFlow è previsto un rimborso parziale proporzionale al periodo di disservizio."],
  ["Effetti del rimborso", "Con il rimborso totale il piano viene revocato e l'account torna al Piano Starter. I preventivi già creati restano consultabili. I rimborsi sono accreditati sullo stesso metodo di pagamento entro 5-10 giorni lavorativi."],
];

export default function RefundPolicyDialog({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="refund-policy-dialog" className="max-w-lg max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><ShieldCheck style={{ width: 18, height: 18 }} className="text-emerald-600" /> Garanzia e Condizioni di Rimborso</DialogTitle>
          <DialogDescription>Rimborso Totale o Parziale: ecco quando e come si applica.</DialogDescription>
        </DialogHeader>
        <ol className="space-y-3 text-sm">
          {CLAUSES.map(([t, d], i) => (
            <li key={i} data-testid={`refund-clause-${i}`} className="rounded-lg border border-slate-200 p-3">
              <p className="font-semibold text-slate-900">{i + 1}. {t}</p>
              <p className="text-slate-600 mt-1 leading-relaxed">{d}</p>
            </li>
          ))}
        </ol>
        <p className="text-xs text-slate-400">Per richiedere un rimborso scrivi all'assistenza dalla chat in alto a sinistra indicando l'email dell'account.</p>
      </DialogContent>
    </Dialog>
  );
}
